import styled from "styled-components";

export const Wrapper = styled.div`
width: 300px;
max-width: 300px;
height: 191px;
svg{
    width: 100%;
}
`;